import React from 'react'
import { Field, SubmitButton } from './AuthLayout'

/**
 * AuthWorkspaceStep — the inline "name your workspace" step shown when a
 * first-time user authenticates but has no tenant yet (exchange returned
 * hasWorkspace: false). Reuses the hook's `createWorkspace` verbatim. Rendered
 * INSIDE the sign-in / sign-up card, so the theme stays identical.
 */
export default function AuthWorkspaceStep({ auth }) {
  const { pending, wsName, setWsName, createWorkspace, busy, useDifferentAccount } = auth
  return (
    <form
      onSubmit={(e) => { e.preventDefault(); createWorkspace() }}
      aria-label="Create your workspace"
    >
      <Field
        label="Workspace name"
        name="workspace"
        value={wsName}
        onChange={setWsName}
        placeholder="Acme Inc."
        autoComplete="organization"
        autoFocus
        required
      />
      <SubmitButton busy={busy} busyLabel="Creating…">Create workspace</SubmitButton>
      <p className="rrauth__back">
        <button type="button" className="rrauth__link" onClick={useDifferentAccount}>
          Use a different account
        </button>
      </p>
    </form>
  )
}
